    export  const isAllValuesEmpty = (content) => {
      if (content === null || content === undefined || content === "") return true;
      if (typeof content === "string" && content.trim() === "") return true;
      if (Array.isArray(content) && content.length === 0) return true;
      return false;
    };